import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import SlideOverlay from "./SlideOverlay";

const SlideDefense = React.memo(function SlideDefense() {
  const [showSecondaryBg, setShowSecondaryBg] = useState(false);
  const [showShield, setShowShield] = useState(false);
  const [initialBounceComplete, setInitialBounceComplete] = useState(false);

  useEffect(() => {
    const secondaryBgTimer = setTimeout(() => {
      setShowSecondaryBg(true);
      setTimeout(() => {
        setShowShield(true);
      }, 2000);
    }, 1000);

    return () => {
      clearTimeout(secondaryBgTimer);
    };
  }, []);

  return (
    <>
      <div
        className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000"
        style={{
          backgroundImage: `url(./carousel_img/defensebg.webp)`,
          backgroundColor: "#1e1e21",
          willChange: "transform",
          contain: "layout style paint",
        }}
      >
        <img
          src="./carousel_img/defensebg.webp"
          alt=""
          className="hidden"
          loading="lazy"
          decoding="async"
        />

        {/* Foreground layer (defensebg2.webp) - show it first */}
        {showSecondaryBg && (
          <div
            className="absolute inset-0 bg-cover bg-center z-[10]"
            style={{
              backgroundImage: `url(./carousel_img/defensebg2.webp)`,
              willChange: "transform",
              contain: "layout style paint",
            }}
          />
        )}

        {/* Shield in the middle with bounce and heartbeat animations */}
        {showShield && (
          <div className="absolute inset-0 flex items-center justify-center z-[5]">
            {!initialBounceComplete ? (
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: [0, 1.2, 0.9, 1.1, 1] }}
                transition={{
                  duration: 1,
                  ease: "easeOut",
                  times: [0, 0.4, 0.6, 0.8, 1],
                }}
                onAnimationComplete={() => setInitialBounceComplete(true)}
                className="flex items-center justify-center"
                style={{ willChange: "transform" }}
              >
                <img
                  src="./carousel_img/shield.webp"
                  alt="Neural Defense Shield"
                  width={600}
                  height={600}
                  loading="lazy"
                  decoding="async"
                  className="w-auto h-auto max-w-[350px] max-h-[350px] sm:max-w-[350px] sm:max-h-[350px] md:max-w-[450px] md:max-h-[450px] lg:max-w-[550px] lg:max-h-[550px] xl:max-w-[600px] xl:max-h-[600px]"
                />
              </motion.div>
            ) : (
              <motion.div
                animate={{ scale: [1, 1.05, 1] }}
                transition={{
                  duration: 1.5,
                  ease: "easeInOut",
                  repeat: Infinity,
                  repeatType: "loop",
                }}
                className="flex items-center justify-center"
                style={{ willChange: "transform" }}
              >
                <img
                  src="./carousel_img/shield.webp"
                  alt="Neural Defense Shield"
                  width={600}
                  height={600}
                  loading="lazy"
                  decoding="async"
                  className="w-auto h-auto max-w-[350px] max-h-[350px] sm:max-w-[350px] sm:max-h-[350px] md:max-w-[450px] md:max-h-[450px] lg:max-w-[550px] lg:max-h-[550px] xl:max-w-[600px] xl:max-h-[600px]"
                />
              </motion.div>
            )}
          </div>
        )}

        <div className="absolute inset-0" />
      </div>

      <SlideOverlay
        label="Future-Proof Your Security"
        title="Neural Defense"
        description="Protect your digital assets with our AI-powered cybersecurity suite, featuring real-time threat detection and automated incident response"
        ctaText="Discover Security"
        ctaUrl="/solutions/neural-networks"
      />
    </>
  );
});

export default SlideDefense;

